import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GlobalMessageType } from '../../../global-message/models/global-message.model';
import { GlobalMessageActions } from '../../../global-message/store/actions/index';
import { normalizeHttpError } from '../../../util';
import { UserProfileConnector } from '../../connectors/user-profile.connector';
import { ForgotUsernameActionTypes } from '../actions/forgot-username.action';
import { UserActions } from '../actions/index';

@Injectable()
export class ForgotUsernameEffects {
  requestForgotUsernameEmail$: Observable<
    UserActions.ForgotUsernameEmailRequestSuccess | UserActions.ForgotUsernameEmailRequestFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ForgotUsernameActionTypes.RequestForgottenUsernameEmail),
      map((action: UserActions.ForgotUsernameEmailRequest) => action.payload),
      switchMap(({ email }) => {
        return this.userProfileConnector.requestForgotUsernameEmail(email).pipe(
          map(() => new UserActions.ForgotUsernameEmailRequestSuccess()),
          catchError((error) => of(new UserActions.ForgotUsernameEmailRequestFail(normalizeHttpError(error))))
        );
      })
    )
  );

  handleSuccessOrError$: Observable<GlobalMessageActions.AddMessage> = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ...[
          ForgotUsernameActionTypes.RequestForgottenUsernameEmailSuccess,
          ForgotUsernameActionTypes.RequestForgottenUsernameEmailFail,
        ]
      ),
      map(
        () =>
          new GlobalMessageActions.AddMessage({
            text: { key: 'username.forgotten.requestForgotUsernameEmailSuccessOrFailure_message' },
            type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
          })
      )
    )
  );

  constructor(private actions$: Actions, private userProfileConnector: UserProfileConnector) {}
}
